var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.blockData.items.length && _vm.blockData.hasRandomItems)?_c('div',{staticClass:"block-type-113"},[(_vm.isMobileView)?_c('BlockType2Grid',{attrs:{"data":_vm.blockData,"settings":_vm.settings}}):_c('BlockType3Grid',{attrs:{"data":_vm.blockData,"settings":_vm.settings}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }